import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../config";

function PostSwapListing() {
  const navigate = useNavigate();

  // ===== STATE =====
  const [swap_from_suburb, setSwapFromSuburb] = useState("");
  const [swap_from_postcode, setSwapFromPostcode] = useState("");

  const [swap_to_suburb, setSwapToSuburb] = useState("");
  const [swap_to_postcode, setSwapToPostcode] = useState("");
  const [swap_to_state, setSwapToState] = useState("");

  const [accessType] = useState("Access Available Anytime");
  const [streetParking, setStreetParking] = useState(false);
  const [schoolZone, setSchoolZone] = useState(false);
  const [hasDogs, setHasDogs] = useState(false);
  const [greenBin, setGreenBin] = useState(false);

  const [serviceDay, setServiceDay] = useState("any");
  const [serviceTime, setServiceTime] = useState("any");

  const [time, setTime] = useState("");
  const [frequency, setFrequency] = useState("fortnightly");
  const [rideOnOrPush, setRideOnOrPush] = useState("Push");
  const [bagMulch, setBagMulch] = useState("Mulch");

  const [frontLawn, setFrontLawn] = useState(false);
  const [rearLawn, setRearLawn] = useState(false);
  const [natureStrip, setNatureStrip] = useState(false);
  const [acreage, setAcreage] = useState(false);

  const [cutValue, setCutValue] = useState("");

  const [disclaimerAccepted, setDisclaimerAccepted] = useState(false);
  const [message, setMessage] = useState("");



  // ===== SUBMIT =====
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const token = localStorage.getItem("token");
      const user = JSON.parse(localStorage.getItem("user"));
      const userId = user?.id;

      if (!userId) {
        setMessage("❌ Missing user ID. Please log in again.");
        return;
      }

      if (!disclaimerAccepted) {
        setMessage("❌ Please accept the disclaimer before posting.");
        return;
      }

      const payload = {
        listingId: "SWAP-" + Math.floor(Math.random() * 999999),
        userId,

        swap_from_suburb,
        swap_from_postcode,
        swap_to_suburb,
        swap_to_postcode,
        swap_to_state,

        accessType,
        streetParking: streetParking ? 1 : 0,
        schoolZone: schoolZone ? 1 : 0,
        hasDogs: hasDogs ? 1 : 0,
        greenBin: greenBin ? 1 : 0,

        serviceDay,
        serviceTime,

        time,
        frequency,
        rideOnOrPush,
        bagMulch,

        frontLawn: frontLawn ? 1 : 0,
        rearLawn: rearLawn ? 1 : 0,
        natureStrip: natureStrip ? 1 : 0,
        acreage: acreage ? 1 : 0,

        cutValue,
        disclaimerAccepted,

        image: null,
      };

      console.log("🧾 Sending swap data:", payload);

      const res = await fetch(`${API_BASE_URL}/api/swap-listings`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      console.log("📦 Swap listing response:", data);

  if (!res.ok) {
  setMessage(
    `❌ ${data.error || data.message || "Failed to post swap listing"}`
  );
} else {
  setMessage("✅ Swap listing posted successfully! Redirecting…");

  const newListingId = data.listingId;
  const publicListingId = data.publicListingId;

  if (newListingId) {
    setTimeout(() => {
      navigate(`/swap-listing-success/${newListingId}`, {
        state: { publicListingId },
      });
    }, 1200);
  } else {
    setTimeout(() => navigate("/dashboard"), 1200);
  }
}
    } catch (err) {
      console.error("❌ Error posting swap listing:", err);
      setMessage("❌ Error posting swap listing. Check console for details.");
    }
  };

  // ===== UI =====
  return (
    <div style={containerStyle}>
      <h2 style={headerTitle}>Post Swap Listing</h2>

      {message && (
        <div
          style={{
            marginBottom: "20px",
            textAlign: "center",
            color: message.includes("❌") ? "#d32f2f" : "#2e7d32",
            fontWeight: 600,
          }}
        >
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit} style={formStyle}>
        {/* ===== SWAP LOCATION ===== */}
        <h3 style={sectionHeader}>Swap Location</h3>

        <label style={boldLabel}>Swap From Suburb:</label>
        <input
          type="text"
          value={swap_from_suburb}
          onChange={(e) => setSwapFromSuburb(e.target.value)}
          required
          style={inputStyle}
        />

        <label style={boldLabel}>Swap From Postcode:</label>
        <input
          type="number"
          value={swap_from_postcode}
          onChange={(e) => setSwapFromPostcode(e.target.value)}
          required
          style={inputStyle}
        />

        <label style={boldLabel}>Swap To Suburb:</label>
        <input
          type="text"
          value={swap_to_suburb}
          onChange={(e) => setSwapToSuburb(e.target.value)}
          required
          style={inputStyle}
        />

        <label style={boldLabel}>Swap To Postcode:</label>
        <input
          type="number"
          value={swap_to_postcode}
          onChange={(e) => setSwapToPostcode(e.target.value)}
          required
          style={inputStyle}
        />

        <label style={boldLabel}>State:</label>
        <select
          value={swap_to_state}
          onChange={(e) => setSwapToState(e.target.value)}
          required
          style={selectStyle}
        >
          <option value="">Select State</option>
          <option value="VIC">VIC</option>
          <option value="NSW">NSW</option>
          <option value="QLD">QLD</option>
          <option value="SA">SA</option>
          <option value="WA">WA</option>
          <option value="TAS">TAS</option>
          <option value="NT">NT</option>
          <option value="ACT">ACT</option>
        </select>

        {/* ===== ACCESS & PARKING ===== */}
        <h3 style={sectionHeaderBlue}>Access & Parking</h3>

        <label style={labelStyle}>
          <input
            type="checkbox"
            checked={streetParking}
            onChange={(e) => setStreetParking(e.target.checked)}
          />
          Street Parking Available
        </label>

        <label style={labelStyle}>
          <input
            type="checkbox"
            checked={schoolZone}
            onChange={(e) => setSchoolZone(e.target.checked)}
          />
          Located in a School Zone
        </label>

        <label style={labelStyle}>
          <input
            type="checkbox"
            checked={hasDogs}
            onChange={(e) => setHasDogs(e.target.checked)}
          />
          Dogs on Property
        </label>

        <label style={labelStyle}>
          <input
            type="checkbox"
            checked={greenBin}
            onChange={(e) => setGreenBin(e.target.checked)}
          />
          Green Bin Available
        </label>

        {/* ===== JOB DETAILS ===== */}
        <h3 style={sectionHeader}>Job Details</h3>

        <label style={boldLabel}>Preferred Day:</label>
        <select
          value={serviceDay}
          onChange={(e) => setServiceDay(e.target.value)}
          style={selectStyle}
        >
          <option value="any">Any Day</option>
          <option value="monday">Monday</option>
          <option value="tuesday">Tuesday</option>
          <option value="wednesday">Wednesday</option>
          <option value="thursday">Thursday</option>
          <option value="friday">Friday</option>
          <option value="saturday">Saturday</option>
          <option value="sunday">Sunday</option>
        </select>

        <label style={boldLabel}>Preferred Time:</label>
        <select
          value={serviceTime}
          onChange={(e) => setServiceTime(e.target.value)}
          style={selectStyle}
        >
          <option value="any">Any reasonable time</option>
          <option value="am">Morning (AM)</option>
          <option value="pm">Afternoon (PM)</option>
        </select>

        <label style={boldLabel}>Estimated Time:</label>
        <select
          value={time}
          onChange={(e) => setTime(e.target.value)}
          required
          style={selectStyle}
        >
          <option value="">Select Duration</option>
          <option value="0.5">30 Minutes</option>
          <option value="1">1 Hour</option>
          <option value="1.5">1 Hour 30 Minutes</option>
          <option value="2">2 Hours</option>
          <option value="3">3 Hours</option>
        </select>

       <label style={boldLabel}>Growing Season Frequency:</label>

<p
  style={{
    fontSize: "0.85rem",
    color: "#666",
    marginTop: "-10px",
    marginBottom: "5px",
  }}
>
  Select the usual mowing frequency during the main growing season.
</p>

<select
  value={frequency}
  onChange={(e) => setFrequency(e.target.value)}
  style={selectStyle}
>
          <option value="weekly">Weekly</option>
          <option value="fortnightly">Fortnightly</option>
          <option value="3weeks">Every 3 Weeks</option>
          <option value="monthly">Monthly</option>
        </select>

        <label style={boldLabel}>Mower Type:</label>
        <select
          value={rideOnOrPush}
          onChange={(e) => setRideOnOrPush(e.target.value)}
          style={selectStyle}
        >
          <option value="Push">Push</option>
          <option value="Ride-on">Ride-on</option>
        </select>

        <label style={boldLabel}>Grass Handling:</label>
        <select
          value={bagMulch}
          onChange={(e) => setBagMulch(e.target.value)}
          style={selectStyle}
        >
          <option value="Mulch">Mulch</option>
          <option value="Bag">Bag</option>
        </select>

        {/* ===== AREAS SERVICED ===== */}
        <h3 style={sectionHeader}>Areas Serviced</h3>

        <label style={labelStyle}>
          <input
            type="checkbox"
            checked={frontLawn}
            onChange={(e) => setFrontLawn(e.target.checked)}
          />
          Front Lawn
        </label>

        <label style={labelStyle}>
          <input
            type="checkbox"
            checked={rearLawn}
            onChange={(e) => setRearLawn(e.target.checked)}
          />
          Rear Lawn
        </label>

        <label style={labelStyle}>
          <input
            type="checkbox"
            checked={natureStrip}
            onChange={(e) => setNatureStrip(e.target.checked)}
          />
          Nature Strip
        </label>

        <label style={labelStyle}>
  <input
    type="checkbox"
    checked={acreage}
    onChange={(e) => setAcreage(e.target.checked)}
  />
  Acreage Property
</label>

        {/* ===== CUT VALUE ===== */}
        <h3 style={sectionHeaderOrange}>Cut Value</h3>

        <label style={boldLabel}>Cut Value ($):</label>
        <input
          type="number"
          placeholder="Cut Value"
          value={cutValue}
          onChange={(e) => setCutValue(e.target.value)}
          required
          style={inputStyle}
        />

        {/* ===== DISCLAIMER ===== */}
   <label style={labelStyle}>
  <input
    type="checkbox"
    checked={disclaimerAccepted}
    onChange={(e) => setDisclaimerAccepted(e.target.checked)}
    required
  />
  I confirm that:
</label>

<ul style={{ fontSize: "0.9rem", color: "#333", marginTop: "8px", marginLeft: "25px" }}>
  <li>All information provided is accurate and not misleading</li>
  <li>I am solely responsible for this listing</li>
  <li>Client Exchange™ does not verify or guarantee listing information</li>
  <li>I have authority to transfer these clients</li>
  <li>This does not breach any agreement (including franchise or contractual obligations)</li>
  <li>
  I agree to be bound by the Client Exchange™ terms,
  conditions, and policies listed on the website from time to time
</li>
</ul>

<p style={{ fontSize: "0.8rem", color: "#666", marginTop: "8px" }}>
  Listings must comply with any applicable agreements or obligations held by the seller.
</p>
<button
  type="submit"
  disabled={!disclaimerAccepted}
  style={{
    ...buttonStyle,
    backgroundColor: disclaimerAccepted ? "#4caf50" : "#9e9e9e",
    cursor: disclaimerAccepted ? "pointer" : "not-allowed",
  }}
>
  Submit Swap Listing
</button>

      </form>
    </div>
  );
}

// ===== STYLES =====
const containerStyle = {
  maxWidth: "95%",
  width: "600px",
  margin: "50px auto",
  padding: "25px",
  backgroundColor: "#fff",
  borderRadius: "12px",
  boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
};

const headerTitle = {
  textAlign: "center",
  marginBottom: "25px",
  color: "#2e7d32",
};

const formStyle = { display: "flex", flexDirection: "column", gap: "18px" };

const inputStyle = {
  padding: "10px",
  borderRadius: "6px",
  border: "1px solid #ccc",
  fontSize: "1rem",
  width: "100%",
};

const selectStyle = { ...inputStyle };

const labelStyle = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  fontSize: "0.95rem",
  flexWrap: "wrap",
};

const boldLabel = { fontWeight: "bold" };

const sectionHeader = {
  borderBottom: "2px solid #4caf50",
  paddingBottom: "5px",
};

const sectionHeaderBlue = {
  borderBottom: "2px solid #0288d1",
  paddingBottom: "5px",
};

const sectionHeaderOrange = {
  borderBottom: "2px solid #ff9800",
  paddingBottom: "5px",
};

const buttonStyle = {
  padding: "16px",
  backgroundColor: "#4caf50",
  color: "#fff",
  fontWeight: "bold",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  fontSize: "1rem",
  transition: "0.3s",
};

export default PostSwapListing;
